import ReactSidebar from "@/components/common/ReactSidebar";
import {
  openAccountSidebar,
  passMsgToAccountSidebar,
} from "@/redux/actions/loggedInUser";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "../Header.module.scss";
import AccountIcon from "@/components/Logos/Account";
import AccountComp from "@/components/Header/Account";
import { useState } from "react";
import { useEffect } from "react";
import { useRouter } from "next/compat/router";

const AccountSidebar = ({ selectIcon,accountColor }) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const [myAccount, setMyAccount] = useState(false);

  const userLoggedIn = useSelector((state) => state.loginUser.userLoggedIn);
  const accountSidebarOpen = useSelector(
    (state) => state.loginUser.open_account_sidebar
  );

  const handleAccountSidebar = (e) => {
    dispatch(openAccountSidebar(e));
  };

  let { pages = [] } = router.query;
  const drawer_section =
    pages && pages.length ? pages[0] : router.pathname.split("/")[1];
  const drawer_tab = pages && pages.length > 1 ? pages[1] : "";
  const drawer_order_id = pages && pages.length > 2 ? pages[2] : "";

  useEffect(() => {
    if (window.innerWidth >= 768) {
      if (
        drawer_section === "account" ||
        drawer_section === "login" ||
        drawer_section === "register" ||
        drawer_section === "activate-account"
      ) {
        if (window.innerWidth <= 990) {
          document.querySelector(".header_account_icon")?.click();
        } else {
          handleAccountSidebar(true);
        }
      }
    }
  }, [router]);

  return (
    <ReactSidebar
      mainContent={
        <div
          tabIndex={0}
          className={`${styles.account_icon} cursor-pointer`}
          onClick={() => {
            dispatch(passMsgToAccountSidebar(""));
          }}
        >
          <AccountIcon
            className="ga_header_account"
            height="22"
            width="20"
            stroke={accountColor?accountColor:"#2f2f30"}
            fill={userLoggedIn&&accountColor?accountColor:userLoggedIn ? "#2f2f30" : "none"}
          />
        </div>
      }
      sidebarContent={
        <AccountComp
          accountSidebarOpen={accountSidebarOpen} 
          setAccountSidebarOpen={handleAccountSidebar}
          drawer_tab={drawer_tab}
          drawer_section={drawer_section}
          drawer_order_id={drawer_order_id}
          myAccount={myAccount}
        />
      }
      handleSidebar={(e) => {
        selectIcon(!accountSidebarOpen ? "user-account" : "");
        handleAccountSidebar(!accountSidebarOpen);
        if (e == false) {
          setMyAccount("account");
        } else {
          setMyAccount(false);
        }
      }}
      sidebarOpen={accountSidebarOpen}
      rootClassName="account-root"
      sidebarClassName="account-sidebar"
      styles={{
        root: {
          position: "relative",
          height: 30,
          width: 25,
        },
        sidebar: {
          position: "fixed",
          overflow: "auto",
        },
      }}
      pullRight={true}
    />
  );
};

export default AccountSidebar;
